import React from 'react'

import { Arrow } from 'components/shared/Arrow/Arrow'
import { TetherPortal } from 'components/shared/TetherPortal/TetherPortal'

import { TooltipPropsContext } from '../../context'

import styles from './Note.module.scss'

export const Note = ({ note }) => {
  const {
    arrowRef,
    arrowStyle,
    floating,
    floatingStyle,
    hasArrow,
    isToggled,
  } = React.useContext(TooltipPropsContext)

  return (
    <TetherPortal isOpen={isToggled}>
      {isToggled ? (
        <div
          className={styles.content}
          ref={floating}
          role="status"
          style={floatingStyle}
        >
          {hasArrow ? (
            <Arrow
              ref={arrowRef}
              size="small"
              style={arrowStyle}
              theme="dark"
            />
          ) : null}
          <span className={styles.text} role="tooltip">
            {note}
          </span>
        </div>
      ) : null}
    </TetherPortal>
  )
}
